import { render, staticRenderFns } from "./UserDashboardFacilitiesHelps.vue?vue&type=template&id=64fcd72c&scoped=true&"
import script from "./UserDashboardFacilitiesHelps.vue?vue&type=script&lang=js&"
export * from "./UserDashboardFacilitiesHelps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fcd72c",
  null
  
)

export default component.exports